import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from '../styles/dialog.module.css';

interface HelpDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content: string | React.ReactNode;
  maxWidth?: string;
  maxHeight?: string;
}

const HelpDialog: React.FC<HelpDialogProps> = ({
  isOpen,
  onClose,
  title = 'Help',
  content,
  maxWidth = '600px',
  maxHeight = '80vh'
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div 
        className={`${styles.dialog} ${styles.help}`}
        style={{ maxWidth, maxHeight }}
      >
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          <button 
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close help dialog"
          >
            ×
          </button>
        </div>
        <div className={`${styles.content} ${styles.helpContent}`}>
          {typeof content === 'string' ? (
            // Check if content contains HTML tags
            content.trim().startsWith('<') ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              <ReactMarkdown>{content}</ReactMarkdown>
            )
          ) : (
            content
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpDialog; 